import React from "react"
import tw, { styled, css } from "twin.macro"

import { SlideProps } from "."

import SlideSection from "../components/slideSection"
import TitleEnrolSquare from "../svgs/titleEnrolSquare"
import TitleEnrolLandscape from "../svgs/titleEnrolLandscape"
import CMForm from "../components/cmForm"

const EnrolSlide: React.SFC<SlideProps> = () => {
  return (
    <SlideSection>
      <div css={[tw`flex flex-col items-center`]}>
        <div
          css={[
            css`
              width: 18.75rem;
            `,
            tw`flex flex-col items-center justify-center`,
          ]}
        >
          <div css={[tw`mb-4`]}>
            <TitleEnrolSquare css={[tw`md:hidden`]} />
            <TitleEnrolLandscape css={[tw`hidden md:block`]} />
          </div>

          <CMForm />
        </div>
      </div>
      <div css={[tw`absolute bottom-0 w-full`]}>
        <div css={[tw`flex justify-center`]}>
          <p
            css={[
              tw`font-sans text-center text-sm my-4 px-4`,
              css`
                max-width: 37rem;
              `,
            ]}
          >
            There’s never been a better time to turbo-charge your CV and
            consider a career in the automotive industry with our FREE
            NZQA-recognised MITO Micro&reg;.
          </p>
        </div>
      </div>
    </SlideSection>
  )
}

export default EnrolSlide
